import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDashboard } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import shc from "../../assets/images/statistics.png";
import pdmc from "../../assets/images/onboardlogo/pdmc.png";
import nfsm from "../../assets/images/onboardlogo/nfsm.png";
import soilhealth from "../../assets/images/onboardlogo/shc.png";
import aif from "../../assets/images/onboardlogo/AIF.png";
import ami from "../../assets/images/onboardlogo/ami.png";
import cropic from "../../assets/images/onboardlogo/cropic.png";
import ACABC from "../../assets/images/onboardlogo/acabc.png"
import RKVY from '../../assets/images/onboardlogo/rkvy.png'
import { Link } from "react-router-dom";
import '../../assets/styles/barhide.css';
import nf from '../../assets/images/onboardlogo/nf.jpg'
import MOVCD from '../../assets/images/onboardlogo/movcd.png'
import seedhub from '../../assets/images/onboardlogo/seedhub.png'
import nfsmnew from '../../assets/images/onboardlogo/nfsmnew.png'
import CHCAppLogo from "../../assets/images/onboardlogo/CHCAppLogo.png";
function Analytics() {
  return (
    <>
      {/* <aside id="myDIV" className="sidebar">
            </aside> */}
      <main id="main" className="main AdminAccess">
        {/* <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Analytic Dashboard</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Analytic Dashboard</li>
            </ol>
          </nav>
          <Link className="btn btn-success backdashbord" to="/AdminAccess"><i class="bi bi-skip-backward"></i> Back</Link>
        </div> */}
        <div className="container-fluid">

          <div className="card">
            <div className="card-body onbordedSchemess analyticsH schemesreport">

              <h3>Asset-Based Scheme</h3>
              <div className='row'>
               
                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://acabcmis.gov.in/ACABC_dashboard_Chart.aspx" target='_blank'>
                      <div className="card-body"><img src={ACABC} />
                      </div>
                      <h6>AC&ABC</h6>
                    </a>
                  </div>
                </div>

                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://agriinfra.dac.gov.in/home/dashboardgeotag" target='_blank'>
                      <div className="card-body"><img src={aif} />
                      </div>
                      <h6>AIF</h6>
                    </a>
                  </div>
                </div>
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                   <a href="https://dmi.gov.in/" target="_blank">
                      <div className="card-body"><img src={ami} />
                      </div>
                      <h6>Agri. Marketing Infrastructure (AMI)</h6>
                    </a>
                  </div>
                </div>

                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://agridashboard.dac.gov.in/Dash2/Rkvy.aspx" target='_blank'>
                      <div className="card-body"><img src={RKVY} />
                      </div>
                      <h6>RKVY</h6>
                    </a>
                  </div>
                </div>

                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://soilhealth.dac.gov.in/home" target='_blank'>
                      <div className="card-body"><img src={soilhealth} />
                      </div>
                      <h6>Soil Health Card</h6>
                    </a>
                  </div>
                </div>

               
               
              
               
               
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://nfsm.gov.in/seedhubdetails.aspx" target='_blank'>
                      <div className="card-body"><img src={seedhub} />
                      </div>
                      <h6>Seed Hub</h6>
                    </a>
                  </div>
                </div>
               
               
               
              </div>
              <h3>Subsidy-Based Scheme</h3>
              <div className='row'>
                  <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://movcd.dac.gov.in/home" target='_blank'>
                      <div className="card-body"><img src={MOVCD} />
                      </div>
                      <h6>MOVCD</h6>
                    </a>
                  </div>
                </div>
                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://naturalfarming.dac.gov.in/" target='_blank'>
                      <div className="card-body"><img src={nf} />
                      </div>
                      <h6>Natural Farming</h6>
                    </a>
                  </div>
                </div>

                 <div className="col-md-2 col-sm-4">

                  <div className="dashboardcard">

                    <a href="https://app.powerbi.com/view?r=eyJrIjoiOWQwZDY3ZjctZTA3ZS00NjkyLWE4N2QtOTk2YzM0YTk0MTIzIiwidCI6IjZlOGUyOGI4LTBhZmUtNGMyNy1hZjI5LTYwMDRmODRjNGY3YSJ9" target="_blank">
                      <div className="card-body"><img src={nfsm} />
                      </div>
                      <h6>
                        NFSM Analytics Dashboard</h6>
                    </a>

                  </div>
                </div>
               
                
               
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://nfsm.gov.in/krishimapper/CFLDSummary.aspx" target='_blank'>
                      <div className="card-body"><img src={nfsmnew} />
                      </div>
                      <h6>NFSM (CFLD)</h6>
                    </a>
                  </div>
                </div>

                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://nfsm.gov.in/statedemonstration.aspx" target='_blank'>
                      <div className="card-body"><img   src={nfsmnew} />
                      </div>
                      <h6>NFSM (State Demonstration)</h6>
                    </a>
                  </div>
                </div>
                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://nfsm.gov.in/krishimapper/Default.aspx" target='_blank'>
                      <div className="card-body"><img src={nfsmnew} />
                      </div>
                      <h6>NFSM (FLD)</h6>
                    </a>
                  </div>
                </div>

                 {/* <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <Link to="/pdmcanalyticA">
                      <div className="card-body"><img src={pdmc} />
                      </div>
                      <h6>PDMC Analytic Dashboard</h6>
                    </Link>
                  </div>
                </div> */}

              </div>

              <h3>Others</h3>
              <div className='row'>
                <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://agrimachinery.nic.in/Index/farmsapp" target='_blank'>
                      <div className="card-body"><img style={{ width: '125px' }}  src={CHCAppLogo} />
                      </div>
                      <h6>FarmsAPP</h6>
                    </a>
                  </div>
                </div>
                 <div className="col-md-2 col-sm-4">
                  <div className="dashboardcard">
                    <a href="https://agrimachinery.nic.in/GraphReport/SMAMFmtti/SMAMFmtti.aspx" target='_blank'>
                      <div className="card-body"><img style={{ width: '125px' }}  src={CHCAppLogo} />
                      </div>
                      <h6>SMAMF</h6>
                    </a>
                  </div>
                </div>
              

              </div>
            </div>
          </div>


        </div>
      </main>
    </>
  );
}
export default Analytics